module.exports = __webpack_public_path__ + "img/info.b8368d66.svg";